import React, { useState } from "react";
import {
    Button,
    Tooltip,
} from "antd";
import {
  DownloadOutlined,
} from "@ant-design/icons";



function DownloadComponent({ handleTelechargement, title }) {


    return (
        <>
            <Tooltip title={title}>
                <Button
                    onClick={handleTelechargement}
                    type="default"
                    icon={<DownloadOutlined />}
                    size="small"
                />
            </Tooltip>
        </>
    )

}

export default DownloadComponent